export default {
  // Sections
  solutions: "Solutions",
  rejoindre: "Join Us",
  expertise: "Expertise",
  "nous-connaitre": "About Us",
  "le-point-reglementaire": "The Regulatory Point",
  
  // Solutions links
  "products-for-installers": "Solutions for pros",
  "find-clients": "Find new clients",
  "crm-erp-gratuit": "Free CRM-ERP",
  "dimensionnement-pv": "PV Sizing",
  "etude-rentabilite": "Profitability Study",
  "outil-visite-technique": "Technical Visit Tool",
  "demarches-administratives": "Administrative Procedures",
  "place-de-marche": "Marketplace",
  administration: "Administrative Management",
  "digital-sales-tools": "Online Studies",
  "resale-agreements": "Purchase Agreements",
  
  // Rejoindre links
  "demander-demo": "Request your demo",
  "installateurs-enr": "Renewable Energy Installers",
  "donneur-ordres": "Contracting Authority",
  "fabricants-fournisseurs": "Manufacturers and Suppliers",
  "devenir-ambassadeur": "Become an ambassador",
  
  // Expertise links
  resources: "Resources",
  "comparateur-acheteurs": "Buyer Comparator",
  "reglementation": "Regulations",
  "centre-aide": "Help Center",
  "contacter-service-client": "Contact customer service",
  blog: "All Articles",
  documentation: "Pro Documentation",
  guide: "Solar Guide",
  "support-centre": "Customer Support",
  
  // Nous connaître links
  partners: "Partnerships",
  enterprise: "Enterprise",
  home: "Our Activity",
  "about-us": "About Us",
  "notre-mission": "Our Mission",
  "company-values": "Our Commitment",
  pricing: "Pricing",
  press: "Press",
  technology: "Technology",
  careers: "Careers",
  ambassadors: "Ambassadors",
  
  // Newsletter
  newsletter: "The Regulatory Point",
  "newsletter-d2c": "Solar Newsletter",
  "subscribe-newsletter":
    "News, updates, exclusives: be at the forefront.",
  "your-email": "Enter your email",
  
  // D2C specific sections
  "demarrer": "Get Started",
  "find-installer": "I want to find an installer",
  "get-study": "I want a study",
  "administrative-process": "I need a process",
  "buy-equipment": "I want to buy equipment",
  "ressources": "Resources",
  "mon-projet-solaire": "My solar project",
  "conseils-accompagnement": "Advice & support",
  "suivi-chantier": "Site monitoring",
  "mon-budget-solaire": "My solar budget",
  "mon-offre-solaire": "My solar offer",
  "simulateur-solaire": "Solar simulator",
  "trouver-mon-installateur": "Find my installer",
  "devenir-installateur": "Become an installer",
  "guides": "Guides",
  "questions-frequentes": "Frequently Asked Questions",
  
  // Legal
  copyright: `${new Date().getFullYear()} © projetsolaire. All rights reserved.`,
  "terms-and-conditions": "Legal Notice",
  "privacy-policy": "Privacy Policy",
  "contact-us": "Contact",
}
